/*=========================================================================================
  File Name: modulePartner.js
  Description: Partner Module
==========================================================================================*/


import state from './modulePartnerState.js'
import mutations from './modulePartnerMutations.js'
import actions from './modulePartnerActions.js'
import getters from './modulePartnerGetters.js'

export default {
  partnerStateList: [
    {value:'0', label:'Новый', color:'warning', tag:'new'},
    {value:'1', label:'Одобрен', color:'success', tag:'approved'},
    {value:'2', label:'Заблокирован', color:'danger', tag:'blocked'},
  ],
  programStateList: [
    {value:'0', label:'На рассмотрении', color:'warning', tag:'consider'},
    {value:'1', label:'Одобрено', color:'success', tag:'approved'},
    {value:'2', label:'Заблокировано', color:'danger', tag:'blocked'},
  ],
  partnerDeviceStateList: [
    {value:'0', label:'Подготовлен к передаче', color:'primary', tag:'prepared'},
    {value:'1', label:'Передано партнеру', color:'primary', tag:'transfered'},
    {value:'2', label:'Возвращено', color:'primary', tag:'backed'},
    {value:'3', label:'Реализовано', color:'primary', tag:'released'},
    {value:'4', label:'Оплачено', color:'primary', tag:'payed'},
    {value:'5', label:'Позиция закрыта', color:'primary', tag:'closed'},
  ],
  isRegistered: false,
	namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
